export const checkForJSON = <T = any>(value: string) => {
  try {
    const json = JSON.parse(value);
    return json as T;
  } catch (error) {
    return value;
  }
};
